<template>
	<div id="main">
		<div class="wrap">
			<p>点击按钮-测试（模拟通电过程）</p>
			<div class="btn-group">
				<button type="button" class="btn btn-primary" @click="wifi1('xeuriuu00','192.168.1.112','小米9')">wifi板1</button>
				<button type="button" class="btn btn-primary" @click="wifi2('io9210ffa','192.168.1.111','tplink-aaaas')">wifi板2</button>
				<button type="button" class="btn btn-primary" @click="wifi3('deiu1133f','192.168.3.101','opp-aaaas')">wifi板3</button>
			</div>
			<form class="form-inline mt-4">
				<label for="pwd">局域网ip：</label>
				<input type="text" class="form-control" placeholder="输入ip搜索" v-model="ipStr">
				<button type="submit" class="btn btn-primary ml-2" @click="search">确认</button>
				<button type="submit" class="btn btn-warning ml-2" @click="reset">重置</button>
			</form>
			<table class="table table-hover mt-4">
				<thead>
					<tr>
						<th>chipId</th>
						<th>局域网ip</th>
						<th>wifi名称</th>
						<th>时间</th>
						<th>操作</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="item of wifiList" v-if="item.disableFlag==0">
						<td>{{item.chipId}}</td>
						<td>{{item.ip}}</td>
						<td>{{item.wifiName}}</td>
						<td>{{timestampToTime(item.updateTime)}}</td>
						<td><button type="button" class="btn btn-primary" @click="test(item.chipId,item.ip)">响应</button><button type="button" class="btn btn-success ml-2" @click="bind(item.chipId)">绑定</button></td>
					</tr>
					<tr v-else class="table-success">
						<td>{{item.chipId}}</td>
						<td>{{item.ip}}</td>
						<td>{{item.wifiName}}</td>
						<td>{{timestampToTime(item.updateTime)}}</td>
						<td><button type="button" class="btn btn-danger" @click="unbind(item.chipId)">解绑</button></td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	import qs from 'qs'
	export default {
		name: 'WifiCrudContent',
		data() {
			return {
				wifiList: [],
				ipStr: ''
			}
		},
		methods: {
			wifi1(chipId, ip, wifiName) {
				this.insertWifi(chipId, ip, wifiName)
			},
			wifi2(chipId, ip, wifiName) {
				this.insertWifi(chipId, ip, wifiName)
			},
			wifi3(chipId, ip, wifiName) {
				this.insertWifi(chipId, ip, wifiName)
			},
			search() {
				axios.get('/itmswcn/arduino/wifi/queryAll?ip=' + this.ipStr)
					.then(this.getDataInfoSucc)
			},
			reset() {
				this.getDataInfo()
			},
			test(chipId, ip) {
				axios.get('http://' + ip + '/' + chipId + '/test/[5/7/300/1]')
					.then(function(res) {
						console.log(res)
					}).catch(function(err) {
						console.log(err.response)
					})
			},
			bind(chipId) {
				var that = this
				axios.get('/itmswcn/arduino/wifi/bind/' + chipId)
					.then(function(res) {
						res = res.data
						if(res.code == 100 && res.data == 1) {
							that.getDataInfo()
						}
					})
			},
			unbind(chipId) {
				var that = this
				axios.get('/itmswcn/arduino/wifi/unbind/' + chipId)
					.then(function(res) {
						res = res.data
						if(res.code == 100 && res.data == 1) {
							that.getDataInfo()
						}
					})
			},
			insertWifi(chipId, ip, wifiName) {
				var formParams = qs.stringify({
					ip: ip,
					chipId: chipId,
					wifiName: wifiName
				})
				axios.post('/itmswcn/arduino/wifi/update', formParams)
					.then(this.insertWifiSucc)
			},
			insertWifiSucc(res) {
				var that = this
				res = res.data
				if(res.code == 100 && res.data) {
					that.getDataInfo()
				}
			},
			getDataInfo() {
				axios.get('/itmswcn/arduino/wifi/queryAll')
					.then(this.getDataInfoSucc)
			},
			getDataInfoSucc(res) {
				res = res.data
				if(res.code == 100 && res.data) {
					this.wifiList = res.data
				}
			},
			timestampToTime(row, column) {
				var date = new Date(row)
				var Y = date.getFullYear() + '-'
				var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
				var D = date.getDate() + ' '
				var h = date.getHours() + ':'
				var m = date.getMinutes() + ':'
				var s = date.getSeconds()
				return Y + M + D + h + m + s
			}
		},
		mounted() {
			this.getDataInfo()
		}
	}
</script>

<style lang="scss" scoped>
	.wrap {
		position: relative;
		width: 1200px;
		margin: 60px auto;
	}
</style>